import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import { CALENDAR_OPENED_SOURCE } from 'owa-expressions-store/lib/store/schema/ExpressionPickerOpenedSource';
import { lazyToggleExpressionPane } from 'owa-expressions-view';

export default function toggleEmojiPicker() {
    const fullComposeViewState = getFullComposeViewState();
    const isExpressionPaneOpen =
        fullComposeViewState &&
        fullComposeViewState.currentSidePaneType == SidePaneType.EmojiPicker;

    lazyToggleExpressionPane.import().then(toggleExpressionPane => {
        toggleExpressionPane(
            !isExpressionPaneOpen /* shouldShow */,
            false /* useFlexPane */,
            CALENDAR_OPENED_SOURCE,
            fullComposeViewState.bodyViewState,
            fullComposeViewState.expressionId
        );
    });
}
